import { render, staticRenderFns } from "./Administradores.vue?vue&type=template&id=0bf98b63&scoped=true"
import script from "./Administradores.vue?vue&type=script&lang=js"
export * from "./Administradores.vue?vue&type=script&lang=js"
import style0 from "./Administradores.vue?vue&type=style&index=0&id=0bf98b63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf98b63",
  null
  
)

export default component.exports